function hasValue(value) {
  if (Array.isArray(value)) return value.length > 0
  if (value && typeof value === 'object') return Object.keys(value).length > 0
  return value !== undefined && value !== null && String(value).trim() !== ''
}

export function getGrowthPlan(payload = {}) {
  const plan = payload?.plan || payload?.activePlan || payload?.growthPlan || payload?.latestPlan || null
  if (hasValue(plan)) return plan

  const planId = payload?.growthStage?.planId || payload?.growthStage?.plan_id
  const planSource = payload?.growthStage?.source || payload?.currentGoal?.source
  if (planId || planSource === 'student_growth_plans') {
    return {
      id: planId || 'growth-summary-plan',
      targetDirection: payload?.currentGoal?.title || '',
      stage: payload?.growthStage?.stage || '',
      source: 'student_growth_plans',
    }
  }

  return null
}

export function getLearningProfile(payload = {}) {
  const profile = payload?.learningProfile || payload?.learning_profile || null
  if (hasValue(profile)) return profile

  const fallbackProfile = payload?.profile || null
  if (
    fallbackProfile?.source === 'student_learning_profiles'
    || fallbackProfile?.source === 'student_growth_profiles'
  ) {
    return fallbackProfile
  }

  return null
}

export function getCareerDirection(payload = {}) {
  const plan = getGrowthPlan(payload)
  const profile = getLearningProfile(payload)
  return payload?.careerDirection
    || payload?.career_direction
    || payload?.currentGoal?.title
    || payload?.targetDirection
    || payload?.target_direction
    || plan?.targetDirection
    || plan?.target_direction
    || plan?.direction
    || profile?.careerDirection
    || profile?.career_direction
    || profile?.careerGoal
    || profile?.goal
    || profile?.direction
    || ''
}

export function getCurrentGrowthStage(payload = {}) {
  const plan = getGrowthPlan(payload)
  return payload?.currentStage
    || payload?.current_stage
    || payload?.growthStage?.stage
    || payload?.dashboard?.currentStage
    || plan?.currentStage
    || plan?.current_stage
    || plan?.stage
    || ''
}

export function hasEffectiveGrowthData(payload = {}) {
  return Boolean(
    hasValue(getLearningProfile(payload))
      || hasValue(getGrowthPlan(payload))
      || hasValue(getCareerDirection(payload))
      || hasValue(getCurrentGrowthStage(payload)),
  )
}

export function getEffectiveGrowthPlan(payload = {}) {
  const plan = getGrowthPlan(payload)
  if (hasValue(plan)) return plan

  if (!hasEffectiveGrowthData(payload)) return null

  const direction = getCareerDirection(payload)
  const stage = getCurrentGrowthStage(payload)
  return {
    id: `growth-data:${direction || stage || 'profile'}`,
    targetDirection: direction || stage || '通用成长路线',
    stage: stage || '',
    source: 'effective_growth_data',
  }
}
